import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import store from '@/store';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		// beforeEnter: (to: any, from: any, next: any) => {
		// 	if (!store.getters.user.email) next({ path: '/main' });
		// 	else next();
		// },
	},

	{
		path: '/venues',
		name: 'venues',
		component: () => import(/* webpackChunkName: "about" */ '../views/Venues.vue'),
	},

	{
		path: '/venue/:id',
		name: 'venue',
		component: () => import(/* webpackChunkName: "about" */ '../views/Venue.vue'),
	},

	{
		path: '/referees',
		name: 'referees',
		component: () => import(/* webpackChunkName: "about" */ '../views/Referees.vue'),
	},

	{
		path: '/players',
		name: 'players',
		component: () => import(/* webpackChunkName: "about" */ '../views/Players.vue'),
	},

	{
		path: '/player/:id',
		name: 'player',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Player.vue'),
	},

	{
		path: '/man-of-the-matches',
		name: 'man-of-the-matches',
		component: () => import('../views/ManOfTheMatches.vue'),
	},

	{
		path: '/man-of-the-match/:id',
		name: 'man-of-the-match',
		component: () => import('../views/ManOfTheMatche.vue'),
	},

	{
		path: '/new-man-of-the-match',
		name: 'new-man-of-the-match',
		component: () => import('../views/NewAddManOfTheMatche.vue'),
	},
	{
		path: '/bookings',
		name: 'bookings',
		component: () => import('../views/Bookings.vue'),
	},

	{
		path: '/match/:id',
		name: 'match',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Match.vue'),
	},

	{
		path: '/coordinators',
		name: 'coordinators',
		component: () => import(/* webpackChunkName: "about" */ '../views/Coordinators.vue'),
	},

	{
		path: '/finals',
		name: 'finals',
		component: () => import(/* webpackChunkName: "about" */ '../views/Finals.vue'),
	},

	{
		path: '/final/:id',
		name: 'final',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Final.vue'),
	},

	{
		path: '/cups',
		name: 'cups',
		component: () => import(/* webpackChunkName: "about" */ '../views/Cups.vue'),
	},

	{
		path: '/tournament/:id',
		name: 'tournament',
		component: () => import(/* webpackChunkName: "about" */ '../views/Tournament.vue'),
	},

	{
		path: '/friendlies',
		name: 'friendlies',
		component: () => import(/* webpackChunkName: "about" */ '../views/Friendlies.vue'),
	},

	{
		path: '/teams',
		name: 'teams',
		component: () => import(/* webpackChunkName: "about" */ '../views/Teams.vue'),
	},

	{
		path: '/team/:id',
		name: 'team',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Team.vue'),
	},

	{
		path: '/leagues',
		name: 'leagues',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Leagues.vue'),
	},

	{
		path: '/league/:id',
		name: 'league',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/League.vue'),
	},

	{
		path: '/new-league',
		name: 'new-league',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewLeague.vue'),
	},

	{
		path: '/new-mini-league',
		name: 'new-mini-league',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewAddonMiniLeagues.vue'),
	},

	{
		path: '/new-finals',
		name: 'new-finals',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewFinals.vue'),
	},

	{
		path: '/new-addon-finals',
		name: 'new-addon-finals',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewAddonFinals.vue'),
	},

	{
		path: '/new-cup',
		name: 'new-cup',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewTournament.vue'),
	},

	{
		path: '/new-friendly',
		name: 'new-friendly',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewFriendly.vue'),
	},

	{
		path: '/new-registration',
		name: 'new-registration',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/NewRegistration.vue'),
	},

	{
		path: '/registrations',
		name: 'registrations',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Registrations.vue'),
	},

	{
		path: '/registration/:id',
		name: 'registration',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Registration.vue'),
	},

	{
		path: '/admin',
		name: 'admin',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/Admin.vue'),
	},

	{
		path: '/user',
		name: 'user',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/UserManagement.vue'),
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});

export default router;
